import 'isomorphic-unfetch';
import { compose } from '../functionalUtils';

function removeLinkRedirections(content = '') {
  const HREF_VALUE = /href="([^>]*)"/g;

  return content.replace(HREF_VALUE, (match, rawHref) => {
    const href = rawHref.split('?q=')[1] || '';
    return `href="${href.split('&')[0]}"`;
  });
}

export function cleanDocumentStyles(googleDocument) {
  const CSS_INLINE_STYLE = /style="([^"]*)"/g;
  const stylesFound = googleDocument.match(CSS_INLINE_STYLE);

  const finalGoogleDocument = (stylesFound || []).reduce((str, style) => {
    const CSS_DISPLAY_PROPERTY = /display:([^;"]+)/g;
    const CSS_FONT_WEIGHT_PROPERTY = /font-weight:([^;"]+)/g;

    const newStyles = [CSS_DISPLAY_PROPERTY, CSS_FONT_WEIGHT_PROPERTY]
      .map(cssPropertyRegex => style.match(cssPropertyRegex))
      .filter(styleMatch => !!styleMatch)
      .map(styleMatch => styleMatch[0])
      .join(';');

    return str.replace(style, newStyles && `style="${newStyles}"`);
  }, googleDocument);

  return finalGoogleDocument;
}

export function addWrapper(content = '') {
  return `<div style="word-break:break-word;">${content}</div>`;
}

export const extractDocumentContent = compose(
  addWrapper,
  cleanDocumentStyles,
  removeLinkRedirections,
);
